import HttpClient from '../utils/HttpClient';

interface PassengersServiceInterface {
    codEmpresa?: number;
    codLocTrab?: number;
    codUsu?: number;
    perfilUsu?: number;
    token: string;
    codFuncionario?: number;
    ativado?: boolean;
    provisorio?: boolean;
    dataInativoAte?: string;
}

class PassengersService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listPassengers = async ({
    codEmpresa,
    codLocTrab,
    codUsu,
    perfilUsu,
    token,
  }: PassengersServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_UsuariosFretado?codEmpresa=${codEmpresa}&codLocTrab=${codLocTrab}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  editPassenger = async ({
    codFuncionario,
    ativado,
    provisorio,
    dataInativoAte,
    codUsu,
    perfilUsu,
    codEmpresa,
    token,
  }: PassengersServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_UsuariosFretado?codfuncionario=${codFuncionario}&ativado=${ativado}&provisorio=${provisorio}&dataInativoAte=${dataInativoAte}&codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };
}

export default new PassengersService();
